import { useMemo } from "@";

// Custom hook to generate table columns
export const useTableColumns = (
  baseColumns, // Base columns for the table
  renderOptions, // Function to render options
  grow = 2, // Column grow factor
  title = "الخيارات", // Column title
) => {
  // Memoize columns to avoid unnecessary re-renders
  return useMemo(() => {
    if (renderOptions) {
      return [
        ...baseColumns,
        {
          name: title,
          grow: grow,
          cell: (row) => (row.id === "customRow" ? null : renderOptions(row)),
        },
      ];
    }

    return [...baseColumns];
  }, [baseColumns, renderOptions, title, grow]);
};
